import { Modal as UniModal } from '@planne-software/uni';
import { Button } from '@planne-software/uni/Button';
import { Box, Stack, Typography, styled } from '@planne-software/uni/mui/material';

export const Root = styled(Stack)(({ theme }) => ({
  '*': {
    fontFamily: theme.typography.fontFamily,
  },

  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100vh - 48px)',
  overflow: 'hidden',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxHeight: '100dvh',
    borderRadius: `${theme.tokens.radius['border-radius-md']} ${theme.tokens.radius['border-radius-md']} 0 0`,
    border: `1px solid ${theme.tokens.colors['border-color-neutral-softer']}`,
    backgroundColor: theme.tokens.colors['fill-color-neutral'],
  },
}));

export const OfferList = styled(Stack)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  padding: theme.tokens.spacing['spacing-sm'],
  gap: theme.tokens.spacing['spacing-2xmini'],
}));

export const OfferRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.tokens.spacing['spacing-mini'],
  width: '100%',
  padding: `${theme.tokens.spacing['spacing-1xmini']} 0`,
  border: 0,
  borderBottom: `1px solid ${theme.tokens.colors['border-color-neutral-soft']}`,
  background: 'transparent',
  textAlign: 'left',

  '&:last-of-type': {
    borderBottom: 0,
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.tokens.spacing['spacing-1xmini'],
    padding: `${theme.tokens.spacing['spacing-none']} 0 ${theme.tokens.spacing['spacing-1xmini']}`,
  },
}));

export const ProductInfo = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.tokens.spacing['spacing-mini'],
  minWidth: 0,

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const ProductPhoto = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 74,
  height: 74,
  flexShrink: 0,
  overflow: 'hidden',
  borderRadius: theme.tokens.radius['border-radius-2xs'],
  backgroundColor: theme.tokens.colors['fill-color-neutral-softest'],
  color: theme.tokens.colors['icon-color-neutral-stronger'],

  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}));

export const ProductName = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-xl-medium'],
  color: theme.tokens.colors['text-color-neutral-strongest'],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const OwnerName = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-md-regular'],
  color: theme.tokens.colors['text-color-neutral-stronger'],
}));

export const PriceAndAction = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.tokens.spacing['spacing-xs'],
  flexShrink: 0,

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    justifyContent: 'space-between',
    gap: theme.tokens.spacing['spacing-1xmini'],
  },
}));

export const PriceInfo = styled(Stack)(({ theme }) => ({
  alignItems: 'flex-end',
  minWidth: 96,

  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
    minWidth: 0,
  },
}));

export const PricePrefix = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-md-regular'],
  color: theme.tokens.colors['text-color-neutral-stronger'],
}));

export const Price = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-xl-bold'],
  color: theme.tokens.colors['text-color-neutral-strongest'],
}));

export const Footer = styled(Stack)(({ theme }) => ({
  borderTop: `1px solid ${theme.tokens.colors['border-color-neutral-soft']}`,
  padding: `${theme.tokens.spacing['spacing-xs']} ${theme.tokens.spacing['spacing-sm']} ${theme.tokens.spacing['spacing-sm']}`,
  gap: theme.tokens.spacing['spacing-xs'],

  [theme.breakpoints.down('sm')]: {
    position: 'relative',
    padding: `${theme.tokens.spacing['spacing-xs']} ${theme.tokens.spacing['spacing-xs']} ${theme.tokens.spacing['spacing-xs']}`,
    boxShadow: '0 -12px 32px rgba(70, 70, 70, 0.1)',
  },
}));

export const SelectedCount = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-md-regular'],
  color: theme.tokens.colors['text-color-neutral-stronger'],
}));

export const Actions = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: theme.tokens.spacing['spacing-mini'],

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column-reverse',
    alignItems: 'stretch',
    gap: theme.tokens.spacing['spacing-mini'],

    '& > button': {
      width: '100%',
    },
  },
}));

export const SecondaryButton = styled(Button)(({ theme }) => ({
  color: theme.tokens.colors['fill-color-primary-base'],
  borderColor: theme.tokens.colors['fill-color-primary-base'],
}));

export const Modal = styled(UniModal)(({ theme }) => ({
  width: '100%',
  maxWidth: '100%',
  margin: 'auto 0 0',
  zIndex: theme.zIndex.modal + 9999,

  [theme.breakpoints.up('sm')]: {
    width: 'auto',
    maxWidth: '47.5rem',
    margin: '0 auto',
  },
}));
